import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import {labels} from '../../../util/utils';

import OutputText from '@ey/canvascoreservices/OutputText';

import Tile from './';
import HrAlt from '../Hr/HrAlt';

const MetricsTile = ({items = [], title = '', showMessage = false}) => {
	const renderMetric = ({onGraphicClick = null, value, label}, i) => {
		const isLast = items.length - 1 === i;
		const props = {
			key: `styled-metrics-tile-${i}`
		};

		if (onGraphicClick) props.onClick = onGraphicClick;

		const hasPercentage = (value ?? '').includes('%');

		return (
			<li {...props}>
				<div className="value" title={value}>
					<OutputText h3 ellipsis className="number">
						{value?.replace('%', '')}
					</OutputText>
					{hasPercentage && <OutputText h3>%</OutputText>}
				</div>
				<span className="key">{label}</span>
				{!isLast && <HrAlt />}
			</li>
		);
	};

	const props = {
		title,
		isEmpty: showMessage,
		emptyTitle: labels.thereIsNoDataToDisplay,
		emptySubtitle: labels.selectadditionalEntitiesToContinue
	};

	return (
		<Tile {...props}>
			<StyledMetrics className="metric-list">{items.map(renderMetric)}</StyledMetrics>
		</Tile>
	);
};

MetricsTile.propTypes = {
	title: PropTypes.string,
	showMessage: PropTypes.bool,
	items: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.string,
			label: PropTypes.element,
			onGraphicClick: PropTypes.func
		})
	)
};

export default MetricsTile;

const StyledMetrics = styled.ul`
	list-style: none;
	padding: 0;
	margin: 0;
	display: flex;
	flex-direction: column;
	gap: var(--spacing-medium);
	li {
		margin: 0;
		display: grid;
		grid-template-columns: var(--px-80) 1fr;
		gap: var(--spacing-large);
		cursor: pointer;
		hr {
			grid-column: span 2;
		}
		.value {
			display: flex;
			justify-self: flex-start;
			& > .number {
				flex-shrink: 20;
			}
		}
	}
`;
